import { render } from "./GrayButton.vue?vue&type=template&id=a470e01e"
import script from "./GrayButton.vue?vue&type=script&lang=js"
export * from "./GrayButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__